export default __webpack_public_path__ + "static/media/digitalcard_person.50b458cc.svg";